export const CHECKOUT_PAYMENT_METHODS = [
  'redsys',
  'redsys_100',
  'transfer',
  'manual',
] as const

export type CheckoutPaymentMethod
  = (typeof CHECKOUT_PAYMENT_METHODS)[number]

export type CardCheckoutPaymentMethod = Extract<
  CheckoutPaymentMethod,
  'redsys' | 'redsys_100'
>

export function isCheckoutPaymentMethod(
  method: string,
): method is CheckoutPaymentMethod {
  return CHECKOUT_PAYMENT_METHODS.includes(method as CheckoutPaymentMethod)
}

export function isCardCheckoutPaymentMethod(
  method: CheckoutPaymentMethod,
): method is CardCheckoutPaymentMethod {
  return method === 'redsys' || method === 'redsys_100'
}

export function resolveCheckoutPaymentMethods(
  methods?: readonly string[],
  shippingError?: boolean,
): CheckoutPaymentMethod[] {
  if (shippingError || !methods?.length) {
    return ['manual']
  }

  if (methods.includes('manual')) {
    return ['manual']
  }

  if (methods.some(method => !isCheckoutPaymentMethod(method))) {
    return ['manual']
  }

  return [...new Set(methods)] as CheckoutPaymentMethod[]
}

export function getCardCheckoutPaymentMethod(
  methods: readonly CheckoutPaymentMethod[],
): CardCheckoutPaymentMethod | null {
  if (methods.includes('redsys_100')) {
    return 'redsys_100'
  }

  if (methods.includes('redsys')) {
    return 'redsys'
  }

  return null
}

export function getDefaultCheckoutPaymentMethod(
  methods: readonly CheckoutPaymentMethod[],
): CheckoutPaymentMethod {
  const cardPaymentMethod = getCardCheckoutPaymentMethod(methods)

  if (cardPaymentMethod) {
    return cardPaymentMethod
  }

  if (methods.includes('transfer')) {
    return 'transfer'
  }

  return 'manual'
}
